export default __webpack_public_path__ + "static/media/gs8-ha-waitlist-dashboard.f0d19b5e.png";